// extracted by mini-css-extract-plugin
module.exports = {"hr":"hr_hr__2MF4h"};